module.exports = __webpack_public_path__ + "static/media/sub-lock.ab0d0683.svg";